import { Composition } from 'atomic-layout'
import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { Box, Card, Flex, Text, Link as ThemeLink } from 'theme-ui'
import Footer from '../components/Footer/Footer'
import LandingPageHeader from '../components/Header/LandingPageHeader'
import AboutPage from '../pages/LandingPage/AboutPage'
import Contacts from '../pages/LandingPage/Contacts'
import DefinitionPage from '../pages/LandingPage/DefinitionPage'
// import DisclaimerPage from '../pages/LandingPage/DisclaimerPage'
import LandingPage from '../pages/LandingPage/LandingPage'
import MechanismPage from '../pages/LandingPage/MechanismPage'
import CreateLaporanPengaduan from '../pages/LaporanPengaduan/CreateLaporanPengaduan'
import LoginPage from '../pages/LoginPage/LoginPage'
import NotFound from '../pages/NotFound/NotFound'

const areas = `
  content
  contacts
`

const areasMd = `
  contacts content
`

function LandingPageRoutes() {
  return (
    <>
      <Routes>
        <Route path="/*" element={<LandingPageHeader />} />
      </Routes>

      <Box sx={{ minHeight: 9, px: [3, 6], py: 6 }}>
        <Routes>
          <Route path="login" element={<LoginPage />} />
          <Route
            path="/laporan-pengaduan/create"
            element={<CreateLaporanPengaduan />}
          />

          <Route
            path="*"
            element={
              <Composition
                areas={areas}
                areasMd={areasMd}
                templateColsMd="1fr 3fr"
                gap="1rem"
              >
                {({ Contacts: ContactsArea, Content }) => {
                  return (
                    <>
                      <ContactsArea>
                        <Contacts />
                      </ContactsArea>

                      <Content>
                        <Routes>
                          <Route index element={<LandingPage />} />
                          <Route path="about" element={<AboutPage />} />
                          {/* <Route
                            path="disclaimer"
                            element={<DisclaimerPage />}
                          /> */}
                          <Route path="mechanism" element={<MechanismPage />} />
                          <Route
                            path="definition"
                            element={<DefinitionPage />}
                          />

                          <Route path="*" element={<NotFound />} />
                        </Routes>
                      </Content>
                    </>
                  )
                }}
              </Composition>
            }
          />
        </Routes>
      </Box>

      <Routes>
        <Route path="/*" element={<Footer />} />
      </Routes>
    </>
  )
}

export default LandingPageRoutes
